export const ReplicationTooltip = () => (
  <>
    When enabled, S3{" "}
    <a
      href="https://docs.aws.amazon.com/AmazonS3/latest/userguide/replication.html"
      target="_blank"
    >
      Replication
    </a>{" "}
    automatically copies objects in this bucket to a destination bucket.
    Replication is enabled by default and can be turned on or off at any time.
  </>
);
